/*
*
* File JS componente Block Gallery Off Screen
*
*/

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import 'swiper/css/bundle';
import Swiper from 'swiper/bundle';

import lightGallery from 'lightgallery';
import 'lightgallery/css/lightgallery-bundle.min.css';

//--------------------------------------------------------------------//


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './gallery-off-screen.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const blockGalleryOffScreen = () => {
    let allGalleryOfScreen = document.querySelectorAll('.gallery-off-screen'); 
    
    if (!allGalleryOfScreen.length) return;
    
    allGalleryOfScreen.forEach( gallery =>
    {
            
        let swiperGallery = gallery.querySelector('.swiper-container'); 
        let arrowPrev = gallery.querySelector('.swiper-button-prev');
        let arrowNext = gallery.querySelector('.swiper-button-next');

        let args = {
            freeMode: true,
            slidesPerView: 'auto',
            breakpoints: {
                0: {
                    spaceBetween: 10,
                },
                768: {
                    spaceBetween: 80,
                },
            },
            navigation: 
            {
                nextEl: arrowNext,
                prevEl: arrowPrev,
            },
            a11y: {
                enabled: true,
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
                firstSlideMessage: 'This is the first slide',
                lastSlideMessage: 'This is the last slide',
                paginationBulletMessage: 'Go to slide {{index}}',
                notificationClass: 'swiper-notification'
            },
        };

        new Swiper(swiperGallery, args);

        lightGallery(gallery.querySelector('.lightgallery'), {
            thumbnail: false,
            animateThumb: false,
            showThumbByDefault: false,
            download: false,
            hideBarsDelay: 1000000000,
            autoplayControls: false,
            hash: false,
            escKey: true,
            keyPress: true,
            licenseKey: 'WQ63Z-598QW-NZ7D5-WPMTB'
        });
    });
}

export default blockGalleryOffScreen;

//--------------------------------------------------------------------//